import React from "react";
import { parseAccentText } from "../../utils/textFormatting";

export function StepHeader({
  title,
  subtitle,
  className = "",
  order = "title-subtitle",
}) {
  const contentOrder =
    order === "subtitle-title" ? "flex-col-reverse" : "flex-col";

  return (
    <div
      className={`text-center space-y-2 flex pb-4 ${contentOrder} ${className}`}
    >
      {title && (
        <h2 className="text-xl leading-7 font-bold text-gray-800 py-1 px-2">
          {parseAccentText(title)}
        </h2>
      )}
      {subtitle && (
        <p className="text-gray-500 text-base py-1 px-2">
          {parseAccentText(subtitle)}
        </p>
      )}
    </div>
  );
}